module.exports = __webpack_public_path__ + "static/img/integate-banner1.73a8930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/integate-banner1.png
// module id = WJUP
// module chunks = 31